export default __webpack_public_path__ + "static/media/Switch_user_small.607296a5.svg";